/**
 * Entry point. Decides which app boots and loads nothing else.
 *
 * Two single-page apps share this bundle and this index.html:
 *
 *   /schools/**   the schools checkout — src/schools/main.ts, its own router,
 *                 its own global CSS (the --mable-* design system)
 *   anything else the existing onboarding app — src/main.ts, exactly as before
 *
 * Both are dynamic imports, so neither app's global stylesheet reaches the
 * other's pages: main.ts pulls in styles/main.css, schools/main.ts pulls in
 * the design system, and each only loads when its path matches. That is the
 * whole reason this file exists — the schools screens are styled by a
 * stylesheet that restyles <body>, <h1>… and would repaint every existing
 * onboarding page if it were simply added to the one app.
 *
 * Nothing in src/router/index.ts changes: the onboarding router never sees a
 * /schools URL, so its catch-all and its "/:view/:practise" parent are
 * unaffected. The hosting already serves index.html for every path (HTML5
 * history mode), so /schools/* needs no infrastructure change.
 */
import { isSchoolsPath } from "./schools/lib/isSchoolsPath";

if (isSchoolsPath(window.location.pathname)) {
  import(/* webpackChunkName: "schools" */ "./schools/main");
} else {
  import(/* webpackChunkName: "onboarding" */ "./main");
}
